import gql from "graphql-tag";

const ADD_COMMENT = gql`
    mutation Comment($name: String!, $comment: String!, $blog: ID!){
        createComment(input: { data: { 
            name: $name, 
            comment: $comment, 
                blog: $blog
                }}
        ){
        comment{
            id,
            name,
            comment,
            createdAt
        }
        }
    }
`
export default ADD_COMMENT